import gql from 'graphql-tag';

const WAREHOUSE_PRODUCT_FRAGMENT = gql`
	fragment warehouseProduct on WarehouseProduct {
		id
		quantity
		defaultOrderQuantity
		lowSellerReserveMode
		lowSellerReservePercent
		lowSellerReserveUnitsOverride
		pickOrder
		leadTime
		leadTimeOverride
		calculatedLeadTime
		effectiveLeadTime
		rootTenant {
			id
			timezone
		}
		tenants {
			id
			timezone
		}
		warehouseProductStatistics {
			id
			averageDailyVends
		}
		expiryBatchPreview
		expiryBatchSummary
		product {
			id
			name
			imageUrl
			isFreshFood
			expiryDatePolicy
			isDiscontinued
			measurementUnit
			caseSize
			shipperSize
			palletSize
			forceQuantityInUnits
			type
			subType
			manufacturer {
				id
			}
			stockSuppliers {
				id
				name
			}
		}
		defaultSupplier {
			id
			name
		}
		warehouse {
			id
			name
		}
		lastPurchaseOrderItem {
			id
			quantity
			notDeliveredAt
			purchaseOrder {
				id
				identifier
				created
			}
			stockDeliveryItem {
				id
				quantity
				deliveredAt
				receivedAt
			}
		}
		lastStockDeliveryItem {
			id
			quantity
			stockDelivery {
				id
				identifier
			}
			deliveredAt
			receivedAt
		}
		lastSuccessfulStockDeliveryItem {
			id
			quantity
			stockDelivery {
				id
				identifier
			}
			deliveredAt
			receivedAt
		}
		deliveryStatusBreakdown
		deliveryStatus
	}
`;

export const GET_WAREHOUSE_PRODUCT_BY_PRODUCT = gql`
query($warehouse: ID, $product: ID) {
	getWarehouseProduct(warehouse: $warehouse, product: $product) {
		...warehouseProduct
	}
}
${WAREHOUSE_PRODUCT_FRAGMENT}
`;

export const GET_WAREHOUSE_PRODUCT_EXPIRY_BATCHES = gql`
	query($id: String) {
		getWarehouseProduct(id: $id) {
			id
			expiryBatches {
				id
				quantityOnHand
				expiryDate
				bestBeforeDate
				supplierBatchCode
				status
				receivedAt
				expiryDateSource
				expiryDateUpdatedAt
				expiryDateUpdatedBy {
					id
					firstname
					lastname
				}
			}
		}
	}
`;


export const GET_WAREHOUSE_PRODUCTS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: WarehouseProductPageFilter
	) {
		getWarehouseProducts(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...warehouseProduct
			}
			count
		}
	}
	${WAREHOUSE_PRODUCT_FRAGMENT}
`;

export const GET_WAREHOUSE_PRODUCTS_FOR_STOCK_MONITORING = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: WarehouseProductPageFilter
	) {
		getWarehouseProducts(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...warehouseProduct
				expirySellThroughRisk
			}
			count
		}
	}
	${WAREHOUSE_PRODUCT_FRAGMENT}
`;

export const GET_WAREHOUSE_ORDERING_RECOMMENDATIONS = gql`
	query(
		$warehouse: ID!,
		$supplier: ID,
		$suppliers: [ID],
		$coverageWeeks: Float,
		$coverageOverrides: JSON,
	) {
		getWarehouseOrderingRecommendations(
			warehouse: $warehouse,
			supplier: $supplier,
			suppliers: $suppliers,
			coverageWeeks: $coverageWeeks,
			coverageOverrides: $coverageOverrides,
		)
	}
`;

export const MODIFY_WAREHOUSE_PRODUCT = gql`
	mutation modifyWarehouseProductMutation($input: ModifyWarehouseProductInput!) {
		modifyWarehouseProduct(input: $input) {
			warehouseproduct {
				...warehouseProduct
			}
		}
	}
	${WAREHOUSE_PRODUCT_FRAGMENT}
`;

export const MODIFY_WAREHOUSE_PRODUCT_QUANTITY = gql`
	mutation applyStocktakeChanges ($id: ID!) {
		applyStocktakeChanges (id: $id) {
			id
			status
		}
	}
`;

export const MODIFY_NORMALISE_PICK_ORDER = gql`
	mutation normalisePickOrders ($id: ID!) {
		normalisePickOrders (id: $id) {
			id
			pickOrder
		}
	}
`;

export const MODIFY_WAREHOUSE_PRODUCT_BATCH = gql`
	mutation modifyWarehouseProductBatchMutation($input: ModifyWarehouseProductBatchInput!) {
		modifyWarehouseProductBatch(input: $input) {
			warehouseProductBatch: warehouseproductbatch {
				id
				expiryDate
				bestBeforeDate
				supplierBatchCode
				status
				receivedAt
				expiryDateSource
				expiryDateUpdatedAt
				expiryDateUpdatedBy {
					id
					firstname
					lastname
				}
			}
		}
	}
`;

export const REMOVE_WAREHOUSE_PRODUCTS = gql`
	mutation removeWarehouseProducts ($warehouseProductsToRemove: [JSON]!) {
		removeWarehouseProducts (warehouseProductsToRemove: $warehouseProductsToRemove)
	}
`;

export const SPOIL_WAREHOUSE_PRODUCTS = REMOVE_WAREHOUSE_PRODUCTS;

export const GET_WAREHOUSE_PRODUCTS_COUNT = gql`
	query (
		$filter: WarehouseProductCountFilter
	){
		countWarehouseProducts(
			filter: $filter,
		)
	}
`;

export const GET_MAX_WAREHOUSE_PRODUCTS_COUNT = gql`
	query {
		countMaxWarehouseProducts
	}
`;
